module.exports = __webpack_public_path__ + "img/pc_03.3b3065c2.png";